// extracted by mini-css-extract-plugin
export var attachButton = "_l5-8";
export var sendButton = "_l5-2";
export var sendDisabled = "_l5-4";
export var sendEnabled = "_l5-3";
export var sendIcon = "_l5-6";
export var sendIconDisabled = "_l5-7";
export var sendStreaming = "_l5-5";
export var textarea = "_l5-1";
export var wrapper = "_l5-0";